import type { LfaServicesV2FieldsFragment } from '~/graphql/types';
import resolveServicesForOffice from '../resolveServicesForOffice';

const hasAnyServicesV2Selected = (
  servicesV2: LfaServicesV2FieldsFragment,
): boolean => {
  if (servicesV2.accountServices.length > 0) return true;

  for (const { officeId } of servicesV2.officeChangesets) {
    const resolved = resolveServicesForOffice({
      accountServices: servicesV2.accountServices,
      officeChangesets: servicesV2.officeChangesets,
      officeId,
    });
    if (resolved.length > 0) return true;
  }

  return false;
};

export default hasAnyServicesV2Selected;
